export default function bannersDataLayer(banners) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ banners: undefined })
    window.dataLayer.push({
      event: 'dados-banner',
      banners: banners.map(banner => {
        return {
          id: banner.Id,
          name: banner.NomeImovel,
          creative: banner.ImgDesk,
          position: banner.Ordem,
        }
      }),
    })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/BI/bannersDataLayer.js